"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateLocation = exports.loadLocationContacts = exports.unclaimLocation = exports.uploadFile = exports.saveLocation = exports.deleteLocation = exports.fetchLocation = exports.fetchLocationReport = exports.loadLocationsWithEmail = exports.loadUserLocations = exports.loadOrgLocations = exports.loadAdminLocationReport = exports.loadAllLocations = exports.default = exports.locationDelete = exports.locationError = exports.locationSuccess = exports.locationLoading = exports.locationReportError = exports.locationReportSuccess = exports.locationReportLoading = exports.locationsError = exports.locationsSuccess = exports.locationsLoading = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _guid = require("../../utils/guid");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var INITIAL_STATE = {
  loading: true,
  locationLoading: false,
  locationReportLoading: true,
  locationIds: null,
  locationMap: {},
  reportMap: {},
  locationError: null,
  filter: null
};
var locationsSlice = (0, _toolkit.createSlice)({
  name: 'locationManager',
  initialState: INITIAL_STATE,
  reducers: {
    locationsLoading: function locationsLoading(state, action) {
      state.loading = action.payload;
    },
    locationsSuccess: function locationsSuccess(state, action) {
      state.loading = false;
      state.locationMap = action.payload.reduce(function (ret, location) {
        ret[location.id] = location;
        return ret;
      }, state.locationMap);
      state.locationIds = Object.keys(state.locationMap);
    },
    locationsError: function locationsError(state, action) {
      state.loading = false;
    },
    locationReportLoading: function locationReportLoading(state, action) {
      state.locationReportLoading = true;
    },
    locationReportSuccess: function locationReportSuccess(state, action) {
      state.locationReportLoading = false;
      state.reportMap[action.payload.locationId] = action.payload.results;
    },
    locationReportError: function locationReportError(state, action) {
      state.locationReportLoading = false;
    },
    locationLoading: function locationLoading(state, action) {
      state.locationLoading = true;
    },
    locationSuccess: function locationSuccess(state, action) {
      state.locationLoading = false;
      state.locationMap[action.payload.id] = action.payload;
      state.locationIds = Object.keys(state.locationMap);
    },
    locationError: function locationError(state, action) {
      state.locationLoading = false;
    },
    locationDelete: function locationDelete(state, action) {
      delete state.locationMap[action.payload];
      state.locationIds = Object.keys(state.locationMap);
    }
  }
});
var _locationsSlice$actio = locationsSlice.actions,
    locationsLoading = _locationsSlice$actio.locationsLoading,
    locationsSuccess = _locationsSlice$actio.locationsSuccess,
    locationsError = _locationsSlice$actio.locationsError,
    locationReportLoading = _locationsSlice$actio.locationReportLoading,
    locationReportSuccess = _locationsSlice$actio.locationReportSuccess,
    locationReportError = _locationsSlice$actio.locationReportError,
    locationLoading = _locationsSlice$actio.locationLoading,
    locationSuccess = _locationsSlice$actio.locationSuccess,
    locationError = _locationsSlice$actio.locationError,
    locationDelete = _locationsSlice$actio.locationDelete;
exports.locationDelete = locationDelete;
exports.locationError = locationError;
exports.locationSuccess = locationSuccess;
exports.locationLoading = locationLoading;
exports.locationReportError = locationReportError;
exports.locationReportSuccess = locationReportSuccess;
exports.locationReportLoading = locationReportLoading;
exports.locationsError = locationsError;
exports.locationsSuccess = locationsSuccess;
exports.locationsLoading = locationsLoading;
var _default = locationsSlice.reducer;
/**
 * Custom Thunk Actions
 */

exports.default = _default;

var loadAllLocations = function loadAllLocations(enqueueSnackbar) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;
    dispatch(locationsLoading(true));
    return api.getAllLocations().then(function (locations) {
      locations.forEach(function (location) {
        if (location.photos && location.photos.length) {}
      });
      return dispatch(locationsSuccess(locations));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationsError);
    });
  };
};

exports.loadAllLocations = loadAllLocations;

var loadAdminLocationReport = function loadAdminLocationReport(setLoading, setReport, enqueueSnackbar) {
  return function (dispatch, getState, _ref2) {
    var api = _ref2.api;
    return api.getAdminLocationReport().then(function (report) {
      setLoading(false);
      setReport(report);
    }).catch(function (error) {
      console.error(error);
      setLoading(false);
      enqueueSnackbar(error.message, {
        variant: 'error'
      });
    });
  };
};
/**
 * Loads all the locationManager for a single organization from Firestore
 */


exports.loadAdminLocationReport = loadAdminLocationReport;

var loadOrgLocations = function loadOrgLocations(orgIds, enqueSnackbar) {
  return function (dispatch, getState, _ref3) {
    var api = _ref3.api;
    console.log("orgIds", orgIds);
    dispatch(locationsLoading(true));
    return api.getOrgLocations(orgIds).then(function (locations) {
      return dispatch(locationsSuccess(locations));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationsError());
    });
  };
};

exports.loadOrgLocations = loadOrgLocations;

var loadUserLocations = function loadUserLocations(orgIds, email, enqueSnackbar) {
  return function (dispatch, getState, _ref4) {
    var api = _ref4.api;
    dispatch(locationsLoading(true));
    return api.getUserLocations(orgIds, email).then(function (locations) {
      return dispatch(locationsSuccess(locations));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationsError());
    });
  };
};

exports.loadUserLocations = loadUserLocations;

var loadLocationsWithEmail = function loadLocationsWithEmail() {
  return function (dispatch, getState, _ref5) {
    var api = _ref5.api;
    dispatch(locationsLoading(true));
    return api.getLocationsWithEmail().then(function (locations) {
      return dispatch(locationsSuccess(locations));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationsError());
    });
  };
};

exports.loadLocationsWithEmail = loadLocationsWithEmail;

var fetchLocationReport = function fetchLocationReport(locationId, startDate, endDate) {
  return function (dispatch, getState, _ref6) {
    var api = _ref6.api;
    dispatch(locationReportLoading(true));
    return api.getLocationReport(locationId, startDate, endDate).then(function (results) {
      return dispatch(locationReportSuccess(results));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationReportError());
    });
  };
};

exports.fetchLocationReport = fetchLocationReport;

var fetchLocation = function fetchLocation(locationId, enqueueSnackbar, onError) {
  return function (dispatch, getState, _ref7) {
    var api = _ref7.api;
    dispatch(locationLoading(true));
    return api.getLocation(locationId).then(function (location) {
      return dispatch(locationSuccess(location));
    }).catch(function (error) {
      console.error(error);
      dispatch(locationError());
      enqueueSnackbar(error.message, {
        variant: 'error'
      });
      if (onError) return onError();
    });
  };
};

exports.fetchLocation = fetchLocation;

var deleteLocation = function deleteLocation(locationId) {
  return function (dispatch, getState, _ref8) {
    var api = _ref8.api;
    return api.deleteLocation(locationId).then(function (result) {
      return dispatch(locationDelete(locationId));
    }).catch(function (error) {
      console.error(error);
    });
  };
};

exports.deleteLocation = deleteLocation;

var saveLocation = function saveLocation(location) {
  var setSaving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var goBack = arguments.length > 2 ? arguments[2] : undefined;
  var geocode = arguments.length > 3 ? arguments[3] : undefined;
  var enqueueSnackbar = arguments.length > 4 ? arguments[4] : undefined;
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState, _ref9) {
      var api, coords;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              api = _ref9.api;

              if (!geocode) {
                _context.next = 12;
                break;
              }

              _context.next = 4;
              return api.geocodeAddress("".concat(location.address.line1, " ").concat(location.address.city, ", ").concat(location.address.stateCode, " ").concat(location.address.zip));

            case 4:
              coords = _context.sent;

              if (!(coords.lat && coords.lng)) {
                _context.next = 10;
                break;
              }

              location.latitude = coords.lat;
              location.longitude = coords.lng;
              _context.next = 12;
              break;

            case 10:
              setSaving(false);
              return _context.abrupt("return", enqueueSnackbar("Error Geocoding Address. Please adjust and try again.", {
                variant: 'error'
              }));

            case 12:
              console.log("savinnnn it");
              return _context.abrupt("return", api.saveLocation(location).then(function (result) {
                console.log("done", result);

                if (goBack) {
                  goBack();
                }

                console.log("saveLocation result", result);
                return dispatch(locationSuccess(result));
              }).catch(function (error) {
                console.error(error);
                setSaving(false);
                enqueueSnackbar(error.message, {
                  variant: 'error'
                });
              }));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref10.apply(this, arguments);
    };
  }();
};

exports.saveLocation = saveLocation;

var uploadFile = function uploadFile(file, setUploading, photos, handlePhotosChange) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref11) {
      var api, downloadUrl, newPhotos;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              api = _ref11.api;
              _context2.next = 3;
              return api.uploadFile(file, (0, _guid.guid)());

            case 3:
              downloadUrl = _context2.sent;
              newPhotos = [].concat(_toConsumableArray(photos), [downloadUrl]);
              handlePhotosChange(newPhotos);
              setUploading(false);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x4, _x5, _x6) {
      return _ref12.apply(this, arguments);
    };
  }();
};

exports.uploadFile = uploadFile;

var unclaimLocation = function unclaimLocation(location) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref13) {
      var api;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              api = _ref13.api;
              return _context3.abrupt("return", api.saveLocation(_objectSpread(_objectSpread({}, location), {}, {
                orgId: null
              })).then(function (result) {
                return dispatch(locationSuccess(result));
              }).catch(function (error) {
                console.error(error);
              }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7, _x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }();
};

exports.unclaimLocation = unclaimLocation;

var loadLocationContacts = function loadLocationContacts(locationId, setLoading, setContacts, enqueueSnackbar) {
  return function (dispatch, getState, _ref15) {
    var api = _ref15.api;
    return api.getLocation(locationId).then(function (location) {
      setLoading(false);
      setContacts([location.phoneNumber].concat(_toConsumableArray(location.users || [])));
    }).catch(function (err) {
      console.error(err);
      setLoading(false);

      if (enqueueSnackbar) {
        enqueueSnackbar(err.message, {
          variant: 'error'
        });
      }
    });
  };
};

exports.loadLocationContacts = loadLocationContacts;

var duplicateLocation = function duplicateLocation(location, setLoading, history, enqueueSnackbar) {
  return function (dispatch, getState, _ref16) {
    var api = _ref16.api;

    var copy = _objectSpread(_objectSpread({}, location), {}, {
      name: "Copy of ".concat(location.name),
      active: false
    });

    delete copy.id;
    delete copy.bulkUploadId;
    return api.saveLocation(copy).then(function (result) {
      setLoading(false);
      dispatch(locationSuccess(result));
      history.push("/admin/".concat(result.id));
    }).catch(function (err) {
      console.error(err);
      setLoading(false);

      if (enqueueSnackbar) {
        enqueueSnackbar(err.message, {
          variant: 'error'
        });
      }
    });
  };
};

exports.duplicateLocation = duplicateLocation;